// extracted by mini-css-extract-plugin
module.exports = {"caption":"CheckBox_caption","editor":"CheckBox_editor","focusedLabel":"CheckBox_focusedLabel","unFocusedLabel":"CheckBox_unFocusedLabel"};